// extracted by mini-css-extract-plugin
export default {"homeSnippetWrapper":"styles_homeSnippetWrapper__xQ4zk"};